import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import moment from "moment";
import swal from "sweetalert";

export default function PerformanceReport() {
  const [user, setUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [statistics, setStatistics] = useState(null);
  const [reportType, setReportType] = useState({ value: "entry", label: "Entry" });

  const reportTypeOptions = [
    { value: "entry", label: "Entry" },
    { value: "book", label: "Book" },
  ];

  // Fetch user data on component mount
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const url =
      "https://farm.royalresort.pk/api/FramUnit/agent?companyid=1";
    try {
      const response = await axios.get(url);
      const userData = response.data.map((u) => ({
        value: u.id,
        label: u.f_name,
      }));
      setUsers(userData);
    } catch (error) {
      console.error("Error fetching users:", error);
      swal({ title: "An error occurred while fetching users.", icon: "error" });
    }
  };

const handleFilter = async () => {
  if (!user) {
    swal({ title: "Please select a user.", icon: "info" });
    return;
  }

  var StartDate = startDate === null ? ' ' : moment(new Date(startDate)).format('YYYY-MM-DD');
  var EndDate = endDate === null ? ' ' : moment(new Date(endDate)).format('YYYY-MM-DD');

  const url = `https://farm.royalresort.pk/api/booking/GetBookingStatistics?companyid=1&BookedBy=${user.value}&startdate=${StartDate}&enddate=${EndDate}&type=${reportType.value}`;
  
  try {
    const response = await axios.get(url);
    if (response.data && Object.keys(response.data).length > 0) {
      setStatistics(response.data);
    } else {
      setStatistics(null);
      swal({ title: "No data found for the selected filters.", icon: "info" });
    }
  } catch (error) {
    console.error("Error fetching statistics:", error);
    swal({ title: "An error occurred while fetching the statistics.", icon: "error" });
  }
};

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
    }).format(amount);
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h3 className="mb-4">Performance Report</h3>
          </div>
            <div className="card-body">
              <div className="row">
                {/* User Select */}
                <div className="col-md-3 mb-3">
                  <label htmlFor="user-select" className="form-label">
                    Select Agent
                  </label>
                  <Select
                    id="user-select"
                    options={users}
                    value={user}
                    onChange={(selectedOption) => setUser(selectedOption)}
                  />
                </div>
                {/* Report Type Select */}
                <div className="col-md-3 mb-3">
                  <label htmlFor="report-type-select" className="form-label">
                    Report Type
                  </label>
                  <Select
                    id="report-type-select"
                    options={reportTypeOptions}
                    value={reportType}
                    onChange={setReportType}
                  />
                </div>
                {/* Date Range Picker */}
                <div className="col-md-4 mb-3">
                  <label className="form-label">Select Date Range</label>
                  <DateRangePicker
                    startDate={startDate}
                    startDateId="start_date_id"
                    endDate={endDate}
                    endDateId="end_date_id"
                    onDatesChange={({ startDate, endDate }) => {
                      setStartDate(startDate);
                      setEndDate(endDate);
                    }}
                    focusedInput={focusedInput}
                    onFocusChange={setFocusedInput}
                    isOutsideRange={() => false}
                    numberOfMonths={1}
                    displayFormat="DD/MM/YYYY"
                  />
                </div>
                {/* Filter Button */}
                <div className="col-md-2 d-flex align-items-end mb-3">
                  <button className="btn btn-primary w-100" onClick={handleFilter}>
                    Submit
                  </button>
                </div>
              </div>
              {/* Display Statistics in Cards */}
              {statistics && (
                <div className="row mt-4">
                  <div className="col mb-3">
                    <div className="card price_card">
                      <div className="card-header">
                        <strong>Total Bookings</strong>
                      </div>
                      <div className="card-body">
                        <p className="card-text price-text">
                          {statistics._Bkc}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col mb-3">
                    <div className="card price_card">
                      <div className="card-header">
                        <strong>Max Booking Amount</strong>
                      </div>
                      <div className="card-body">
                        <p className="card-text price-text">
                          {statistics._Max
                            ? formatCurrency(statistics._Max)
                            : "0.00"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col mb-3">
                    <div className="card price_card">
                      <div className="card-header">
                        <strong>Min Booking Amount</strong>
                      </div>
                      <div className="card-body">
                        <p className="card-text price-text">
                          {statistics._Min
                            ? formatCurrency(statistics._Min)
                            : "0.00"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col mb-3">
                    <div className="card price_card">
                      <div className="card-header">
                        <strong>Average Booking Amount</strong>
                      </div>
                      <div className="card-body">
                        <p className="card-text price-text">
                          {statistics._Avg
                            ? formatCurrency(statistics._Avg)
                            : "0.00"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col mb-3">
                    <div className="card price_card">
                      <div className="card-header">
                        <strong>Total Amount</strong>
                      </div>
                      <div className="card-body">
                        <p className="card-text price-text">
                          {statistics._Total
                            ? formatCurrency(statistics._Total)
                            : "0.00"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col mb-3">
                    <div className="card price_card">
                      <div className="card-header">
                        <strong>5% Commission</strong>
                      </div>
                      <div className="card-body">
                        <p className="card-text price-text">
                          {statistics._Perc
                            ? formatCurrency(statistics._Perc)
                            : "0.00"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}
